import { forwardRef, useEffect, useRef } from 'react';
import {
  Grid
} from '@mui/material';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import moment from 'moment';
import { AddWorkModel } from 'src/models/leave';

interface CalanderProps {
  workModelValues?: AddWorkModel,
  disabled?: boolean,
  setSelectedDates?: (e: any) => void,
}

const Calander = forwardRef((props: CalanderProps, _ref) => {
  const calendarRef = useRef(null);

  useEffect(() => {
    if(props?.workModelValues?.fromDate){
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(props?.workModelValues?.fromDate);
    }
  }, [props?.workModelValues]);

  return (
    <Grid item xs={12}>
      <FullCalendar
        ref={calendarRef}
        datesSet={() => {
          const calendarEl = document.querySelector('.fc');
          const dayCells = calendarEl.querySelectorAll('td');

          dayCells.forEach((dayCell) => {
            const date = dayCell.getAttribute('data-date');
            const dateMoment = new Date(date);
            const info = { el: dayCell, date: dateMoment };
            const cell = info.el;

            if(new Date(moment(info.date).format('YYYY-MM-DD')) >= new Date(moment(props?.workModelValues?.fromDate).format('YYYY-MM-DD')) && 
              new Date(moment(info.date).format('YYYY-MM-DD')) <= new Date(moment(props?.workModelValues?.toDate).format('YYYY-MM-DD'))){
              if(props?.workModelValues?.frequency !== 'CUSTOM'){
                cell.style.pointerEvents = 'none';
                if(props?.workModelValues?.selectedDates.includes(moment(info.date).format('YYYY-MM-DD'))){
                  cell.classList.add('work-model-selected-date');
                }
              } else{
                if(props?.workModelValues?.selectedDates.includes(moment(info.date).format('YYYY-MM-DD'))){
                  cell.classList.add('work-model-selected-date');
                }
              }
            } else{
              if(cell.getAttribute('role') !== 'presentation'){
                cell.classList.add('work-model-disable-date');
                cell.style.pointerEvents = 'none';
              }
            }

            if(info.date.getDay() === 0 || (info.date.getDay() === 6)){
              cell.classList.add('work-model-disable-date');
              cell.style.pointerEvents = 'none';
            }
          });
        }}
        
        height={window.innerHeight - window.innerHeight * (40 / 100)}
        plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
        selectable={!props?.disabled}
        initialView="dayGridMonth"
        dateClick={(res: any) => {
          if((res.date.getDay() !== 1 || res.date.getDay() !== 6) && props?.workModelValues.frequency === 'CUSTOM'){
            if(new Date(moment(res.date).format('YYYY-MM-DD')) >= new Date(moment(props?.workModelValues?.fromDate).format('YYYY-MM-DD')) && 
            new Date(moment(res.date).format('YYYY-MM-DD')) <= new Date(moment(props?.workModelValues?.toDate).format('YYYY-MM-DD'))){
              const isExsit = props?.workModelValues.selectedDates.includes(res.dateStr);
              if(isExsit){
                res.dayEl.classList.remove('work-model-selected-date')
                props?.setSelectedDates(props?.workModelValues.selectedDates.filter(e => e !== res.dateStr))
              } else {
                res.dayEl.classList.add('work-model-selected-date')
                props?.setSelectedDates([...props?.workModelValues.selectedDates, res.dateStr]);
              }
            }
          }
        }}
      />
    </Grid>
  );
});

export default Calander;
